import {
  RESET_TEMP_CURRENCY_CONVERSION_FIELDS,
  RESET_TRANSACTION_DETAILS,
  SAVE_BENEFICIARY_ID,
  SET_SEND_MONEY_PAYLOAD,
  SAVE_IN_TEMP_CONVERTOR_REDUCER,
  SAVE_TEMP_COUPON_CODE,
  SAVE_TRANSACTION_DETAILS,
  SEND_MONEY_SUBMIT,
  TEMP_CURRENCY_CONVERSION_FIELDS,
  UPDATE_SEND_MONEY,
  MULTI_TXN_RECIPIENT_LIST,
  MULTI_TXN_RECIPIENT_LIST_TEMP_ID,
  MULTI_TXN_INITIATE_TXN,
  MULTI_TXN_CLEAR_RECIPIENT,
  MULTI_TXN_CLEAR_RECIPIENT_EXCEPT_INITIALISED_TXN,
  SET_CORPORATE_CONFIG,
  GET_CURRENCY_RATE,
  UPDATE_RECIPIENT_LIST,
  STORE_FROM_VAL_TO_EDIT,
  SET_POINTS_DATA,
  SET_COUPON_DATA,
  REPLACE_RECIPIENT_LIST_ITEM,
  STORE_PAYMENT_METHOD,
  SAVE_BENE_DATA,
  SAVE_SELECTED_BENE_DATA,
  AML_CHECK_ADDED,
  SAVE_SELECTED_CASHPICK_UP,
  CLEAN_SELECTED_CASHPICK_UP,
  STORE_CASHPICK_UP_RESPONSE,
  STORE_RECENT_ADDED_BENE,
  MULTI_TXN_CURRENT_BENE,
  DISABLE_SUBMIT_BUTTON,
  SBM_REFERRAL_TRANSACITION_CONSENT_ADDED,
  ADD_INSTAPOINTS,
  ADD_REFERRAL_REWARD,
  SAVE_UPSELLING_CMS_POPUP_CONTENTS,
  SAVE_TRANSACTION_COMPARISON_DETAILS,
  SET_BENE_ADDITIONAL_INFO_VALUE,
  SET_BENE_ADDRESS_FOR_PAYIN_METHODS,
  SET_PAYMENT_METHOD_PAYLOAD,
  SAVE_NEW_COUPON_CODE,
  TOGGLE_NEW_COUPON_CODE_APPLIED,
  SAVE_NEW_COUPON_AMOUNT,
  SAVE_MIN_SOURCE_AMOUNT_FOR_COUPON,
  SAVE_COUPON_CMS_DATA,
  SAVE_COUPON_DATA,
  SAVE_NON_FORMATTED_COUPON_DATA,
  SAVE_PROMOTIONS_CMS_CONTENTS,
  SAVE_SELECTED_SCHEMA_BENE_VALIDATIONS,
  SAVE_SELECTED_CONFIG_BENE_VALIDATIONS,
  SET_APPLY_UNIFORM_REFERRAL_DISCOUNT
} from '../../action-contants';

const INITIAL_STATE = {
  currencyCovertor: {
    fromForm: '',
    is_destination_amount_last_changed: false,
    coupon_code: null
  },
  recentAddedBeneIdList: [],
  goodsServicesFormValForEdit: {},
  transactionDetails: {
    selectedCashPickUp: { text: '' }
  },
  newCouponCode: null,
  newCouponAmount: 0,
  minSourceAmountForCoupon: 0,
  isNewCouponCodeApplied: false,
  applyUniformReferralDiscount: false,
  storedCouponData: [],
  storedNonFormattedCouponData: [],
  couponCMSData: {},
  multipleTransactions: {
    recipientList: [],
    totalYouPayAmount: 0,
    initiateTransactions: {},
    corporateConfig: {},
    multiTxnCurrentBene: {}
  },
  reuterRate: {},
  couponData: {
    isCouponError: false
  },
  pointsData: {
    isPointError: false
  },
  sendMoneyNotes: [],
  showDisclaimer: false,
  disableSubmitButton: false,
  upsellingCMSContent: {},
  promotionsCMSData: {},
  selectedConfigBeneValidation: {},
  selectedSchemaBeneValidation: {}
};

export default function transactionReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case STORE_FROM_VAL_TO_EDIT:
      return {
        ...state,
        goodsServicesFormValForEdit: { ...action.data }
      };
    case TEMP_CURRENCY_CONVERSION_FIELDS: {
      return {
        ...state,
        currencyCovertor: { ...state.currencyCovertor, ...action.data }
      };
    }
    case RESET_TEMP_CURRENCY_CONVERSION_FIELDS: {
      let is_destination_amount_last_changed =
        state.currencyCovertor.is_destination_amount_last_changed;
      return {
        ...state,
        currencyCovertor: {
          ...state.currencyCovertor,
          ...INITIAL_STATE.currencyCovertor,
          is_destination_amount_last_changed
        }
      };
    }
    case SAVE_IN_TEMP_CONVERTOR_REDUCER: {
      return {
        ...state,
        currencyCovertor: { ...state.currencyCovertor, ...action.data }
      };
    }
    case SAVE_BENE_DATA: {
      return { ...state, selectedBene: action.data };
    }
    case SAVE_COUPON_DATA: {
      return { ...state, storedCouponData: action.data };
    }
    case SAVE_NON_FORMATTED_COUPON_DATA: {
      return { ...state, storedNonFormattedCouponData: action.data };
    }
    case SAVE_COUPON_CMS_DATA: {
      return { ...state, couponCMSData: action.data };
    }
    case SAVE_NEW_COUPON_CODE: {
      return { ...state, newCouponCode: action.data };
    }
    case SAVE_MIN_SOURCE_AMOUNT_FOR_COUPON: {
      return { ...state, minSourceAmountForCoupon: action.data };
    }
    case TOGGLE_NEW_COUPON_CODE_APPLIED: {
      return {
        ...state,
        isNewCouponCodeApplied: action.data,
        newCouponCode: action.data ? state.newCouponCode : null,
        newCouponAmount: action.data ? state.newCouponAmount : 0,
        minSourceAmountForCoupon: action.data ? state.minSourceAmountForCoupon : 0
      };
    }
    case SAVE_NEW_COUPON_AMOUNT: {
      return {
        ...state,
        newCouponAmount: action.data
      };
    }
    case SET_APPLY_UNIFORM_REFERRAL_DISCOUNT: {
      return {
        ...state,
        applyUniformReferralDiscount: action.data
      };
    }
    case SAVE_SELECTED_BENE_DATA: {
      // hard coded check for IN transaction flow if there is tax_type present
      const additionalInfo =
        state.transactionDetails &&
        state.transactionDetails.additional_info &&
        state.transactionDetails.additional_info['tax_type_1']
          ? state.transactionDetails.additional_info
          : {};
      return {
        ...state,
        transactionDetails: {
          ...state.transactionDetails,
          selectedBene: action.data,
          selectedCashPickUp: { text: '' },
          additional_info: additionalInfo
        }
      };
    }
    case SAVE_SELECTED_CONFIG_BENE_VALIDATIONS: {
      return {
        ...state,
        selectedConfigBeneValidation: action.data
      };
    }
    case SAVE_SELECTED_SCHEMA_BENE_VALIDATIONS: {
      return {
        ...state,
        selectedSchemaBeneValidation: action.data
      };
    }
    case SET_POINTS_DATA: {
      let pointsData = {
        ...state.pointsData,
        isPointError: action.data
      };
      return { ...state, pointsData };
    }
    case SET_COUPON_DATA: {
      let couponData = {
        ...state.couponData,
        isCouponError: action.data
      };
      return { ...state, couponData };
    }

    case RESET_TRANSACTION_DETAILS: {
      return { ...state, transactionDetails: {} };
    }
    case SAVE_TRANSACTION_DETAILS:
    case SEND_MONEY_SUBMIT:
    case UPDATE_SEND_MONEY:
    case SAVE_BENEFICIARY_ID:
    case SET_BENE_ADDITIONAL_INFO_VALUE:
    case SET_BENE_ADDRESS_FOR_PAYIN_METHODS: {
      const mutatedData =
        action.data.additional_info && Object.keys(action.data.additional_info).length === 0
          ? {
              ...action.data,
              additional_info: { ...state.transactionDetails.additional_info }
            }
          : action.data;
      let transactionDetails = {
        ...state.transactionDetails,
        ...mutatedData,
        selectedBene: {
          ...state.transactionDetails.selectedBene,
          ...(action.type === SET_BENE_ADDITIONAL_INFO_VALUE && {
            beneficiary_additional_info_required: action.data.beneficiary_additional_info_required
          }),
          ...(action.type === SET_BENE_ADDRESS_FOR_PAYIN_METHODS && {
            beneficiary_address_collection_for_payin_methods: {
              address_required: action.data.address_required
            }
          })
        },
        total_fee_amount:
          (action.data.transaction_config && action.data.transaction_config.total_fee_amount) ||
          action.data.total_fee_amount
      };
      return { ...state, transactionDetails };
    }

    case SAVE_UPSELLING_CMS_POPUP_CONTENTS:
      return {
        ...state,
        upsellingCMSContent: action.data
      };
    case SAVE_PROMOTIONS_CMS_CONTENTS:
      return {
        ...state,
        promotionsCMSData: action.data
      };
    case SAVE_SELECTED_CASHPICK_UP: {
      return {
        ...state,
        transactionDetails: {
          ...state.transactionDetails,
          selectedCashPickUp: {
            ...action.data
          }
        }
      };
    }
    case CLEAN_SELECTED_CASHPICK_UP: {
      return {
        ...state,
        transactionDetails: {
          ...state.transactionDetails,
          selectedCashPickUp: { text: '' }
        }
      };
    }
    case STORE_CASHPICK_UP_RESPONSE: {
      return {
        ...state,
        transactionDetails: {
          ...state.transactionDetails,
          savedCashPickUp: { ...action.data }
        }
      };
    }
    case SAVE_TEMP_COUPON_CODE: {
      let currencyCovertor = {
        ...state.currencyCovertor,
        coupon_code: action.data
      };
      return { ...state, currencyCovertor };
    }
    case AML_CHECK_ADDED: {
      let transactionDetails = { ...state.transactionDetails };
      transactionDetails.is_aml_checked = action.data;
      return { ...state, transactionDetails };
    }
    case SBM_REFERRAL_TRANSACITION_CONSENT_ADDED: {
      let transactionDetails = { ...state.transactionDetails };
      transactionDetails.sbm_referral_transaction_consent = action.data;
      return { ...state, transactionDetails };
    }
    //multiple transactions
    case MULTI_TXN_RECIPIENT_LIST: {
      let { recipientList, totalYouPayAmount = state.multipleTransactions.totalYouPayAmount } =
          action.data,
        multipleTransactions = {
          ...state.multipleTransactions,
          recipientList,
          totalYouPayAmount
        };
      return { ...state, multipleTransactions };
    }
    case MULTI_TXN_RECIPIENT_LIST_TEMP_ID: {
      let multipleTransactions = {
        ...state.multipleTransactions,
        recipientList: action.data
      };
      return { ...state, multipleTransactions };
    }
    case MULTI_TXN_INITIATE_TXN: {
      let multipleTransactions = {
        ...state.multipleTransactions,
        initiateTransactions: action.data
      };
      return { ...state, multipleTransactions };
    }
    case MULTI_TXN_CLEAR_RECIPIENT: {
      let multipleTransactions = {
        recipientList: [],
        totalYouPayAmount: 0,
        initiateTransactions: {}
      };
      return { ...state, multipleTransactions };
    }
    case MULTI_TXN_CLEAR_RECIPIENT_EXCEPT_INITIALISED_TXN: {
      let multipleTransactions = {
        ...state.multipleTransactions,
        recipientList: [],
        totalYouPayAmount: 0
      };
      return { ...state, multipleTransactions };
    }
    case SET_CORPORATE_CONFIG: {
      return { ...state, corporateConfig: action.data };
    }
    case GET_CURRENCY_RATE: {
      return { ...state, reuterRate: action.data };
    }
    case UPDATE_RECIPIENT_LIST: {
      const { index, value } = action.data;
      const updateCurrentReceipent = state.multipleTransactions.recipientList.map((list, i) => {
        if (i === index) {
          return Object.assign({}, JSON.parse(JSON.stringify(state)), {
            ...list,
            payload: {
              ...list.payload,
              additional_info: { ...value }
            },
            beneficiaryDataToBeShown: {
              ...list.beneficiaryDataToBeShown,
              additional_info: { ...value }
            },
            additionalDetails: {
              ...value
            },
            confirm: true
          });
        } else {
          return list;
        }
      });

      return {
        ...state,
        multipleTransactions: {
          ...state.multipleTransactions,
          recipientList: updateCurrentReceipent
        }
      };
    }
    case MULTI_TXN_CURRENT_BENE:
      return {
        ...state,
        multiTxnCurrentBene: action.data
      };

    case REPLACE_RECIPIENT_LIST_ITEM: {
      const { index, value } = action.data;
      const updateCurrentReceipent = state.multipleTransactions.recipientList.map((list, i) => {
        if (i === index) {
          return value;
        } else {
          return list;
        }
      });

      return {
        ...state,
        multipleTransactions: {
          ...state.multipleTransactions,
          recipientList: updateCurrentReceipent
        }
      };
    }
    case STORE_PAYMENT_METHOD:
      return {
        ...state,
        paymentMethod: action.response,
        sendMoneyNotes: action.response
          .map((obj) => ({
            title: obj.display_name,
            notes: obj.upgrade_limit_display_message
          }))
          .filter((obj) => obj.notes && obj.notes !== null),
        showDisclaimer: action.showDisclaimer || state.showDisclaimer
      };
    case DISABLE_SUBMIT_BUTTON:
      return {
        ...state,
        disableSubmitButton: action.value
      };
    case STORE_RECENT_ADDED_BENE:
      return {
        ...state,
        recentAddedBeneIdList: state.recentAddedBeneIdList.concat(action.data)
      };
    case ADD_INSTAPOINTS:
      return {
        ...state,
        transactionDetails: {
          ...state.transactionDetails,
          redeemed_instapoints: action.data
        }
      };
    case ADD_REFERRAL_REWARD:
      return {
        ...state,
        transactionDetails: {
          ...state.transactionDetails,
          redeemed_referral_rewards: action.data?.redeemed_referral_rewards ?? null,
          redeemed_referral_reward_amount: action.data?.redeemed_referral_reward_amount ?? null,
          redeemed_instapoints: null,
          redeemed_instapoints_amount: null
        }
      };
    case SAVE_TRANSACTION_COMPARISON_DETAILS: {
      return {
        ...state,
        comparisonDetails: action?.data
      };
    }
    case SET_SEND_MONEY_PAYLOAD: {
      return {
        ...state,
        sendMoneyData: {
          ...state.sendMoneyData,
          ...action.data
        }
      };
    }
    case SET_PAYMENT_METHOD_PAYLOAD: {
      return {
        ...state,
        paymentMethodData: {
          ...state.paymentMethodData,
          ...action.data
        }
      };
    }

    default:
      return state;
  }
}
